import Styled from 'styled-components';
import { Datapoint } from '@amount/frontend-components';

const DatapointLabelWrapper = Styled(Datapoint)`
  font-size: ${props => props.theme?.datapointLabel.size};
`;

export default DatapointLabelWrapper;
